module.exports = __webpack_public_path__ + "static/Tastea7-9dcc4cd5d8dc10c83e4b338b231b0c48.jpg";